export var isPbTimestamp = function(timestamp) {
    return (timestamp === null || timestamp === void 0 ? void 0 : timestamp.seconds) != null;
};
